import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null; // Пустое значение проверяется Validators.required
        }

        // Пытаемся распарсить дату
        let date: Date;

        // Формат YYYY-MM-DD (из input type="date")
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
            const [year, month, day] = value.split('-').map(Number);
            date = new Date(year, month - 1, day);
        }
        // Формат DD.MM.YYYY (если пользователь вводит вручную)
        else if (/^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
            const [day, month, year] = value.split('.').map(Number);
            date = new Date(year, month - 1, day);
        } else {
            return { invalidDateFormat: true }; // Неверный формат
        }

        // Проверяем, что дата валидна (не 55.55.5555)
        if (isNaN(date.getTime())) {
            return { invalidDate: true };
        }

        // Проверяем, что день, месяц и год совпадают (защита от 31.02.2020)
        const [inputDay, inputMonth, inputYear] = value.includes('-')
            ? value.split('-').map(Number).reverse()
            : value.split('.').map(Number);

        if (
            date.getDate() !== inputDay ||
            date.getMonth() !== inputMonth - 1 ||
            date.getFullYear() !== inputYear
        ) {
            return { invalidDate: true };
        }

        // Проверяем, что дата не в будущем
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (date > today) {
            return { futureDate: true };
        }

        // Проверяем, что дата не слишком старая (120 лет)
        const minDate = new Date();
        minDate.setFullYear(today.getFullYear() - 120);
        if (date < minDate) {
            return { dateTooOld: true };
        }

        return null;
    };
}
